import { makeStyles } from '@material-ui/core/styles'
const useStyles = makeStyles(
  () => ({
    layout: {
      // border: '2px solid red',
      margin: '10px 20px 10px 0px',
      height: '700px',
      display: 'flex',
      flexDirection: 'column',
      justifyContent: 'flex-start',
    },
    detailsreview: {
      display: 'flex',
      flexDirection: 'row',
      justifyContent: 'space-between',
      height: '620px',
    },
    statustext: {
      display: 'flex',
      justifyContent: 'space-between',
      alignItems: 'center',
      margin: '20px 30px 0px 0px',
      color: '#F37320',
      fontWeight: 'bold',
    },
    showreasontext: {
      fontSize: '14px',
      color: '#2079F3',
      fontWeight: 'normal',
      textDecoration: 'underline',
      cursor: 'pointer',
    },
    errorIcon: {
      color: '#F37320',
      width: '82px',
      height: '82px',
    },
    errorText: {
      color: '#565657',
      fontSize: '20px',
      fontWeight: 'bold',
      textAlign: 'center',
    },
    modalWrapper: {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
    },
    confirmedMessage: {
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      width: '320px',
    },
    rejectedMessage: {
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      width: '440px',
    },
    siteStatus: {
      display: 'flex',
      justifyContent: 'space-around',
      alignItems: 'center',
      width: '340px',
    },

  }),
  { index: 1 },
)

export { useStyles }
